<template>
    <div>
        <h1>
            Chart
        </h1>
        <connections-graph></connections-graph>
    </div>
</template>

<script>
    import ConnectionsGraph from './connections-graph'

    export default {
        components: {
            'connections-graph': ConnectionsGraph
        },
        data () {
            return { }
        },
        methods: {

            skConsoleNumberToHtmlColour: function (number) {
                switch (number) {
                    case 9: return '#428bca';
                    case 14: return '#f0ad4e';
                    case 8: return '#999999';
                    case 12: return '#d9534f';
                    case 2: return '#5cb85c';
                    case 7: return '#cccccc';
                    default: return '#ffffff';
                }
            },
        }
    }
</script>

<style>

</style>
